import { useQuery } from '@tanstack/react-query';
import { Interval } from '@ui/constants/poll';
import { useDataChainId } from '@ui/hooks/datachain';
import { genesisAirdropControllerApi } from '@ui/services/backend/clients/clients';
import { Address, zeroAddress } from 'viem';
import { usePublicClient } from 'wagmi';

import { getGenesisAirdrop } from '../../contract-instances/getGenesisAirdrop';

export const useUserTeamInfo = (user?: Address) => {
  const chainId = useDataChainId();
  const client = usePublicClient({
    chainId,
  });

  return useQuery({
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchInterval: Interval.NORMAL,
    // staleTime: 0,
    queryKey: ['useUserTeamInfo', user, chainId, client?.uid],
    queryFn: async () => {
      if (!client) throw 'client not found';
      if (!user) {
        return {
          leaderTeam: null,
          memberTeam: null,
        };
      }

      const response = await genesisAirdropControllerApi.getUserTeamInfoGZuys9o(
        {
          userAddress: user || zeroAddress,
        },
      );

      return response;
    },
    enabled: !!client,
  });
};
